<div class="flex flex-col gap-5 p-5">
  @if (pageLoading()) {
    <app-loading />
  } @else if (pageError()) {
    <div class="flex flex-col items-center justify-center gap-4 py-20 text-center">
      @if (errorType() === "forbidden") {
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 16 16">
          <path
            class="fill-danger-text"
            fill-rule="evenodd"
            d="m7.493.015l-.386.04c-1.873.187-3.76 1.153-5.036 2.579C.66 4.211-.057 6.168.009 8.253c.115 3.601 2.59 6.65 6.101 7.518a8.03 8.03 0 0 0 6.117-.98a8 8 0 0 0 3.544-4.904c.172-.701.212-1.058.212-1.887s-.04-1.186-.212-1.887C14.979 2.878 12.315.498 9 .064C8.716.027 7.683-.006 7.493.015m1.36 1.548a6.3 6.3 0 0 1 1.987.597c.698.34 1.18.686 1.747 1.253A6 6 0 0 1 13.84 5.16c.445.915.646 1.798.646 2.84a6.2 6.2 0 0 1-.66 2.867c-.172.351-.519.914-.681 1.105l-.055.065l-4.563-4.564L3.963 2.91l.065-.055c.191-.162.754-.509 1.105-.681a6.44 6.44 0 0 1 3.72-.611M7.48 8.534l4.56 4.561l-.067.053a7.7 7.7 0 0 1-1.106.68a6.8 6.8 0 0 1-1.987.616c-.424.065-1.336.065-1.76 0c-1.948-.296-3.592-1.359-4.627-2.993a7.5 7.5 0 0 1-.634-1.332a6.6 6.6 0 0 1-.189-3.584a6.8 6.8 0 0 1 1.096-2.388c.07-.095.133-.173.141-.173s2.065 2.052 4.573 4.56" />
        </svg>
        <h2 class="text-xl font-bold text-gray-800">{{ isArabic() ? "غير مصرح بالوصول" : "Access Denied" }}</h2>
        <p class="max-w-sm text-sm text-gray-500">{{ pageError() }}</p>
      } @else if (errorType() === "not-found") {
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 16 16">
          <path
            class="fill-danger-text"
            fill-rule="evenodd"
            d="m7.493.015l-.386.04c-1.873.187-3.76 1.153-5.036 2.579C.66 4.211-.057 6.168.009 8.253c.115 3.601 2.59 6.65 6.101 7.518a8.03 8.03 0 0 0 6.117-.98a8 8 0 0 0 3.544-4.904c.172-.701.212-1.058.212-1.887s-.04-1.186-.212-1.887C14.979 2.878 12.315.498 9 .064C8.716.027 7.683-.006 7.493.015m1.36 1.548a6.3 6.3 0 0 1 1.987.597c.698.34 1.18.686 1.747 1.253A6 6 0 0 1 13.84 5.16c.445.915.646 1.798.646 2.84a6.2 6.2 0 0 1-.66 2.867c-.172.351-.519.914-.681 1.105l-.055.065l-4.563-4.564L3.963 2.91l.065-.055c.191-.162.754-.509 1.105-.681a6.44 6.44 0 0 1 3.72-.611M7.48 8.534l4.56 4.561l-.067.053a7.7 7.7 0 0 1-1.106.68a6.8 6.8 0 0 1-1.987.616c-.424.065-1.336.065-1.76 0c-1.948-.296-3.592-1.359-4.627-2.993a7.5 7.5 0 0 1-.634-1.332a6.6 6.6 0 0 1-.189-3.584a6.8 6.8 0 0 1 1.096-2.388c.07-.095.133-.173.141-.173s2.065 2.052 4.573 4.56" />
        </svg>
        <h2 class="text-xl font-bold text-gray-800">{{ isArabic() ? "الطلب غير موجود" : "Request Not Found" }}</h2>
        <p class="max-w-sm text-sm text-gray-500">{{ pageError() }}</p>
      } @else {
        <svg
          class="stroke-danger-text"
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 24 24"
          fill="none"
          stroke-width="1.5">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <h2 class="text-xl font-bold text-gray-800">{{ isArabic() ? "حدث خطأ" : "Something Went Wrong" }}</h2>
        <p class="max-w-sm text-sm text-gray-500">{{ pageError() }}</p>
      }
      <button
        onclick="history.back()"
        class="border-primary text-primary hover-bg-primary mt-2 rounded-[6px] border px-5 py-2 text-sm font-medium transition-colors hover:cursor-pointer hover:text-white">
        {{ isArabic() ? "رجوع" : "Go Back" }}
      </button>
    </div>
  } @else if (pharmacyData(); as data) {
    <div class="flex flex-wrap items-baseline justify-start gap-4">
      <h1 class="text-primary max-w-full text-xl leading-none font-bold break-words">
        {{ data.nickName }}
      </h1>
      <div class="flex items-center gap-3">
        @if (requestDataLoading()) {
          <div class="flex h-7 w-[130px] items-center justify-center rounded-full border border-gray-200 bg-gray-100">
            <svg
              class="animate-spin text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5">
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
          </div>
        } @else if (requestData()?.currentStatus) {
          <app-status-badge
            [status]="requestData()!.currentStatus!.titleEn"
            [displayText]="getTranslatedTitle(requestData()!.currentStatus)"
            size="sm"
            customClass="px-3 h-7 w-[130px]" />
        } @else if (requestDataError()) {
          <app-error-data [title]="requestDataError()" />
        }
      </div>
    </div>

    <div class="border-b border-gray-200">
      <nav class="-mb-px flex gap-8" aria-label="Tabs">
        <button
          *hasScope="SCOPES.PHARMACIES.READ_DETAILS"
          (click)="setActiveTab('pharmacy-details')"
          [ngClass]="
            activeTab() === 'pharmacy-details'
              ? 'border-primary text-primary'
              : 'hover-border-primary hover-text-primary border-transparent text-gray-500'
          "
          class="border-b-2 pb-3 text-sm font-medium transition-colors hover:cursor-pointer"
          i18n="@@tabPharmacyDetails">
          Pharmacy Details
        </button>
        <button
          *hasScope="SCOPES.PHARMACIES.READ_REQUEST_DETAILS"
          (click)="setActiveTab('request-details')"
          [ngClass]="
            activeTab() === 'request-details'
              ? 'border-primary text-primary'
              : 'hover-border-primary hover-text-primary border-transparent text-gray-500'
          "
          class="border-b-2 pb-3 text-sm font-medium transition-colors hover:cursor-pointer"
          i18n="@@tabRequestDetails">
          Request Details
        </button>
        <button
          *hasScope="SCOPES.PHARMACIES.READ_REQUEST_LOGS"
          (click)="setActiveTab('history-log')"
          [ngClass]="
            activeTab() === 'history-log'
              ? 'border-primary text-primary'
              : 'hover-border-primary hover-text-primary border-transparent text-gray-500'
          "
          class="border-b-2 pb-3 text-sm font-medium transition-colors hover:cursor-pointer"
          i18n="@@tabRequestHistoryLog">
          Request History Log
        </button>
      </nav>
    </div>

    <div class="rounded-lg bg-white p-4 shadow-sm">
      @if (activeTab() === "pharmacy-details") {
        <app-view-pharmacy-details [data]="data" [isAdmin]="true" />
      } @else if (activeTab() === "request-details") {
        @if (requestDataLoading()) {
          <app-loading />
        } @else if (requestDataError()) {
          <app-error-data [title]="requestDataError()" />
        } @else if (requestData(); as reqData) {
          <app-view-request-details [data]="reqData" [isAdmin]="true" />
        } @else {
          <app-empty-data [title]="isArabic() ? 'لا توجد تفاصيل طلب.' : 'No request details available.'" />
        }
      } @else {
        <app-view-pharmacy-history
          [pharmacyId]="data.id"
          [requestId]="requestData()?.requestId || 0"
          [currentStatus]="requestData()?.currentStatus?.titleEn || 'Pending'"
          [isAdmin]="true" />
      }
    </div>

    @if (currentActions().length > 0) {
      <div class="flex flex-wrap gap-3">
        @for (action of currentActions(); track action.id) {
          @if (isPrimaryAction(action)) {
            @if (isAcceptAction(action)) {
              <button
                *hasScope="SCOPES.PHARMACIES.APPROVE"
                (click)="handleAction(action, data)"
                class="bg-primary hover-bg-primary-hover order-first rounded-[6px] px-5 py-2 text-sm font-medium text-white transition-colors hover:cursor-pointer">
                {{ getTranslatedTitle(action) }}
              </button>
            } @else if (isEditAction(action)) {
              <button
                *hasScope="SCOPES.PHARMACIES.SUBMIT_MODIFICATION"
                (click)="handleAction(action, data)"
                class="bg-primary hover-bg-primary-hover order-first rounded-[6px] px-5 py-2 text-sm font-medium text-white transition-colors hover:cursor-pointer">
                {{ getTranslatedTitle(action) }}
              </button>
            }
          } @else {
            @if (isAssignAction(action)) {
              <button
                *hasScope="SCOPES.PHARMACIES.ASSIGN_EMPLOYEE"
                (click)="handleAction(action, data)"
                class="bg-primary hover-bg-primary-hover rounded-[6px] px-5 py-2 text-sm font-medium text-white transition-colors hover:cursor-pointer">
                {{ getTranslatedTitle(action) }}
              </button>
            } @else if (isReassignAction(action)) {
              <button
                *hasScope="SCOPES.PHARMACIES.REASSIGN_EMPLOYEE"
                (click)="handleAction(action, data)"
                class="border-primary text-primary hover-bg-primary rounded-[6px] border px-5 py-2 text-sm font-medium transition-colors hover:cursor-pointer hover:text-white">
                {{ getTranslatedTitle(action) }}
              </button>
            } @else if (action?.titleEn?.toLowerCase() === "reject pharmacy") {
              <button
                *hasScope="SCOPES.PHARMACIES.REJECT"
                (click)="handleAction(action, data)"
                class="border-primary text-primary hover-bg-primary rounded-[6px] border px-5 py-2 text-sm font-medium transition-colors hover:cursor-pointer hover:text-white">
                {{ getTranslatedTitle(action) }}
              </button>
            } @else if (action?.titleEn?.toLowerCase() === "request modification") {
              <button
                *hasScope="SCOPES.PHARMACIES.REQUEST_MODIFICATION"
                (click)="handleAction(action, data)"
                class="border-primary text-primary hover-bg-primary rounded-[6px] border px-5 py-2 text-sm font-medium transition-colors hover:cursor-pointer hover:text-white">
                {{ getTranslatedTitle(action) }}
              </button>
            } @else if (isCancelAction(action)) {
              <button
                *hasScope="SCOPES.PHARMACIES.CANCEL_REQUEST"
                (click)="handleAction(action, data)"
                class="border-primary text-primary hover-bg-primary rounded-[6px] border px-5 py-2 text-sm font-medium transition-colors hover:cursor-pointer hover:text-white">
                {{ getTranslatedTitle(action) }}
              </button>
            }
          }
        }
      </div>
    }
  }

  @if (assigningEmployeePharmacyId()) {
    <app-assign-employee-dialog
      [type]="modalType()"
      [pharmacyId]="assigningEmployeePharmacyId()!"
      [nickname]="pharmacyData()!.nickName"
      (close)="closeAssignEmployeeDialog()"
      (employeeAssign)="onEmployeeAssigned($event)"
      [prevEmployeeId]="requestData()?.assignedTo?.id" />
  }

  @if (rejectingPharmacyId()) {
    <app-pharmacy-reason-dialog
      type="reject"
      title="Reject Request"
      i18n-title="@@adminViewPharmacyRejectTitle"
      label="Reason for rejection"
      i18n-label="@@adminViewPharmacyRejectLabel"
      placeholder="Write your reason here"
      i18n-placeholder="@@adminViewPharmacyRejectPlaceholder"
      subtitle="Are you sure you want to reject this request?"
      i18n-subtitle="@@adminViewPharmacyRejectSubtitle"
      confirmButtonText="Reject"
      i18n-confirmButtonText="@@adminViewPharmacyRejectButton"
      (close)="closeRejectDialog()"
      [pharmacyId]="rejectingPharmacyId()!"
      (rejectionPharmacy)="onReject($event)" />
  }

  @if (modifyingPharmacyId()) {
    <app-pharmacy-reason-dialog
      type="modify"
      title="Request Modification"
      i18n-title="@@adminViewPharmacyModifyTitle"
      label="Reason for modification"
      i18n-label="@@adminViewPharmacyModifyLabel"
      placeholder="Write your reason here"
      i18n-placeholder="@@adminViewPharmacyModifyPlaceholder"
      subtitle="Are you sure you want to send this request for modification?"
      i18n-subtitle="@@adminViewPharmacyModifySubtitle"
      confirmButtonText="Send"
      i18n-confirmButtonText="@@adminViewPharmacySendButton"
      (close)="closeModifyDialog()"
      [pharmacyId]="modifyingPharmacyId()!"
      (employeeRequestModification)="onModify($event)" />
  }

  @if (approvingPharmacyId()) {
    <app-approve-pharmacy-dialog
      [pharmacyId]="approvingPharmacyId()!"
      [pharmacyName]="pharmacyData()!.nickName"
      (close)="closeApproveDialog()"
      (success)="onApproveSuccess()" />
  }

  @if (cancelingPharmacyId()) {
    <app-cancel-pharmacy-dialog
      [pharmacyRequestId]="pharmacyRequestId()"
      [errorCancel]="errorCancel()"
      [loadingCancel]="loadingCancel()"
      [pharmacyName]="cancelingPharmacyName()!"
      (close)="closeCancelDialog()"
      (confirm)="onRequestCancelled()" />
  }
</div>

@if (successRequestModification()) {
  <app-successful-notification
    type="success"
    [title]="isArabic() ? 'تم طلب التعديل بنجاح' : 'modification requested successfully'" />
}
